import { render, staticRenderFns } from "./DiyoboNameUpdateModal.vue?vue&type=template&id=7e85efda&scoped=true&"
import script from "./DiyoboNameUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DiyoboNameUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./DiyoboNameUpdateModal.vue?vue&type=style&index=0&id=7e85efda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../buyers/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e85efda",
  null
  
)

export default component.exports